<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="companyName">
        <span slot="label">
          <a-tooltip>公司名称<template slot="title">公司名称</template></a-tooltip>
        </span>
        <a-input v-model="form.companyName" :maxLength="32" :placeholder="$t('请输入')+'公司名称'"/>
      </a-form-model-item>
      <a-form-model-item prop="companyBankNo">
        <span slot="label">
          <a-tooltip>银行账号<template slot="title">银行账号</template></a-tooltip>
        </span>
        <a-input v-model="form.companyBankNo" :maxLength="32" :placeholder="$t('请输入')+'银行账号'"/>
      </a-form-model-item>
      <a-form-model-item prop="companyBankName">
        <span slot="label">
          <a-tooltip>开户银行<template slot="title">开户银行</template></a-tooltip>
        </span>
        <a-input v-model="form.companyBankName" :maxLength="32" :placeholder="$t('请输入')+'开户银行'"/>
      </a-form-model-item>
      <a-form-model-item prop="companyBankBranchCode">
        <span slot="label">
          <a-tooltip>开户支行行联号<template slot="title">开户支行行联号</template></a-tooltip>
        </span>
        <a-input v-model="form.companyBankBranchCode" :placeholder="$t('请输入')+'开户支行行联号'"/>
      </a-form-model-item>
      <a-form-model-item prop="companyTax">
        <span slot="label">
          <a-tooltip>公司税号<template slot="title">公司税号</template></a-tooltip>
        </span>
        <a-input v-model="form.companyTax" :maxLength="32" :placeholder="$t('请输入')+'公司税号'"/>
      </a-form-model-item>
      <a-form-model-item prop="companyContactPhone">
        <span slot="label">
          <a-tooltip>电话<template slot="title">电话</template></a-tooltip>
        </span>
        <a-input v-model="form.companyContactPhone" :maxLength="32" :placeholder="$t('请输入')+'电话'"/>
      </a-form-model-item>
      <a-form-model-item prop="companyRegisterAddress">
        <span slot="label">
          <a-tooltip>地址<template slot="title">地址</template></a-tooltip>
        </span>
        <a-input v-model="form.companyRegisterAddress" :maxLength="64" :placeholder="$t('请输入')+'地址'"/>
      </a-form-model-item>
      <a-form-model-item prop="isDefault">
        <span slot="label">
          <a-tooltip>是否默认<template slot="title">是否默认 1:是,0:否</template></a-tooltip>
        </span>
        <a-radio-group v-model="form.isDefault" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getBusinessAccount, addBusinessAccount, updateBusinessAccount} from '@/api/platform/businessAccount'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        merchantId: null,
        companyName: null,
        companyBankNo: null,
        companyBankName: null,
        companyBankBranchCode: null,
        companyTax: null,
        companyContactPhone: null,
        companyRegisterAddress: null,
        isDefault: true,
        deptId: null,
        createTime: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        companyName: [{required: true, message: '公司名称' + this.$t('不能为空'), trigger: 'blur'}],
        companyBankNo: [{required: true, message: '银行账号' + this.$t('不能为空'), trigger: 'blur'}],
        companyBankName: [{required: true, message: '开户银行' + this.$t('不能为空'), trigger: 'blur'}],
        companyTax: [{required: true, message: '公司税号' + this.$t('不能为空'), trigger: 'blur'}],
        companyRegisterAddress: [{required: true, message: '地址' + this.$t('不能为空'), trigger: 'blur'}],
        companyBankBranchCode: [{required: true, message: '开户支行行联号' + this.$t('不能为空'), trigger: 'blur'}],
        companyContactPhone: [{required: true, message: '电话' + this.$t('不能为空'), trigger: 'blur'}],
        isDefault: [{required: true, message: '是否默认 1:是,0:否' + this.$t('不能为空'), trigger: 'blur'}],
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        merchantId: null,
        companyName: null,
        companyBankNo: null,
        companyBankName: null,
        companyBankBranchCode: null,
        companyTax: null,
        companyContactPhone: null,
        companyRegisterAddress: null,
        isDefault: true,
        createTime: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBusinessAccount({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateBusinessAccount(this.form).then(response => {
              this.$message.success(message, 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addBusinessAccount(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
